import { render, staticRenderFns } from "./CalmAvatarUpload.vue?vue&type=template&id=47877ab4&scoped=true&"
import script from "./CalmAvatarUpload.vue?vue&type=script&lang=js&"
export * from "./CalmAvatarUpload.vue?vue&type=script&lang=js&"
import style0 from "./CalmAvatarUpload.vue?vue&type=style&index=0&id=47877ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47877ab4",
  null
  
)

export default component.exports